<template>
  <div class="flex flex-col items-start space-y-12">
    <b class="text-16px leading-18px title-divided self-start">
      Фото семейного захоронения
    </b>
    <div class="photo-upload">
      <VueUpload
        ref="upload"
        v-model="data"
        :input-id="$uniqid()"
        @input-filter="onInputFilter"
        @input-file="onInputFile">
        <div class="flex flex-row items-center space-x-4 cursor-pointer">
          <template v-if="!payload">
            <template v-if="!data.length">
              <div class="upload-select"></div>
              <span>Загрузить</span>
            </template>
            <template v-else>
              <div class="upload-image">
                <img
                  :src="data[0].blob"
                  v-if="data[0].blob">
                <Attachment
                  :id="data[0]"
                  v-else/>
              </div>
              <span>Изменить</span>
            </template>
          </template>
        </div>
      </VueUpload>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import VueUpload from 'vue-upload-component';
import Attachment from '@/components/global/Attachment.vue';

export default {
  components: {
    VueUpload,
    Attachment,
  },
  props: {
    payload: {
      type: String,
      required: false,
    },
    value: {
      type: Array,
      required: false,
      default: () => ([]),
    },
  },
  data() {
    return {
      data: this.value,
    };
  },
  methods: {
    ...mapActions({
      send: 'attachments/ACT_UPLOAD_ATTACHMENT',
    }),
    onInputFilter(newOne, oldOne) {
      if (newOne && !oldOne) {
        // eslint-disable-next-line no-param-reassign
        newOne.blob = '';
        if ((window.URL || window.webkitURL) && URL.createObjectURL) {
          // eslint-disable-next-line no-param-reassign
          newOne.blob = URL.createObjectURL(newOne.file);
        }
      }
    },
    onInputFile() {
      this.$emit('input', this.data);
    },
  },
};
</script>
